export default __webpack_public_path__ + "static/media/logo-acc.3c5a5d21.png";